module.exports = __webpack_public_path__ + "img/1.d348d8fa.png";